import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-customer-company-list',
    templateUrl: './company-list.component.html',
    styleUrls: ['./company-list.component.scss'],
    standalone: false
})
export class CustomerCompanyListComponent {
  @Input() companyList: [] = [];
  @Input() isReadOnlyAdmin: boolean;
  @Input() searchValue: string;
  @Input() currentYear: number;
  @Input() isAdmin: boolean;
  @Input() currentPage: number;
  @Input() itemsPerPage: number;
  @Input() showError: boolean;
  @Input() pageErrorMessage: string;
  @Output() onOpenCompanyInformation = new EventEmitter();
  @Output() onCommentClick = new EventEmitter();
  @Output() onValidationSummaryClick = new EventEmitter();
  @Output() onDeleteButtonClick = new EventEmitter();
  @Output() onNextActionClick = new EventEmitter();
  displayField: string = '';

  openCompanyInformation(compno, compname, groupcode, prfStatus) {
    const data = {
      compNo: compno,
      compName: compname,
      groupCode: groupcode,
      prfStatus: prfStatus
    };
    this.onOpenCompanyInformation.emit(data);
  }
  openComment(comment: string) {
    this.onCommentClick.emit(comment);
  }
  navigateToValidationSummary(compno, compname, groupcode) {
    const data = {
      compNo: compno,
      compName: compname,
      groupCode: groupcode,
    };
    this.onValidationSummaryClick.emit(data);
  }
  deleteCompany(compno, groupcode, originalsubmissiondate) {
    const data = {
      compNo: compno,
      groupCode: groupcode,
      originalsubmissiondate: originalsubmissiondate,
    };
    this.onDeleteButtonClick.emit(data);
  }

  redirectToNextActionPage(compno, groupcode, prfyear) {
    const data = {
      prfnumber: compno,
      groupcode: groupcode,
      prfyear: prfyear
    };
    this.onNextActionClick.emit(data);
  }
}
